import styled from "@emotion/styled";

export const ShareSocialMediaLinksWrapper = styled.div(({theme, styles}) => ({
  position: theme?.breakpoints?.isMobile ? "absolute" : "inherit",
  right: 10,
  top: 70,
  display: "flex",
  flexDirection: theme?.breakpoints?.isMobile ? "column" : "row",
  justifyContent: theme?.breakpoints?.isMobile ? "flex-start" : "center",
  alignItems: "center",
  gap: 14,
  ...styles,
}));
